import aws from '@/auth/aws'
import { elementType } from '@/vars'
import Link from '@/elements/Link'

export const traceColors = [
  {
    node: 'darkorange',
    edge: 'orange'
  },
  {
    node: 'darkred',
    edge: 'red'
  },
  {
    node: 'darkgreen',
    edge: 'green'
  }
]

export const graphColors = {
  selected: {
    node: {
      start: 'gray',
      success: 'green',
      failure: 'red'
    },
    edge: 'gray'
  },
  unselected: {
    node: {
      start: 'lightgray',
      success: 'lightgray',
      failure: 'lightgray'
    },
    edge: 'lightgray'
  }
}

/* eslint-disable no-shadow */
function getDefaultState() {
  return {
    traces: [],
    selectedLogIdIndex: 0,
    selectedSnapshot: {
      suggestions: []
    },
    otherLogIdIndex: 0,
    otherSnapshot: {
      suggestions: []
    }
  }
}

const state = getDefaultState()

const getters = {
  traces: (state) => state.traces,
  isLoadingTraces: (state) => state.isLoadingTraces,
  selectedLogIdIndex: (state) => state.selectedLogIdIndex,
  selectedSnapshot: (state) => state.selectedSnapshot,
  otherLogIdIndex: (state) => state.otherLogIdIndex,
  otherSnapshot: (state) => state.otherSnapshot
}

const actions = {
  clearUserElements: async ({ getters, dispatch, rootGetters }, namespaceElement) => {
    if (namespaceElement === '') {
      console.log('clear player elements')
      Promise.all(getters.userPlacedElements.map(async (el) => dispatch('removeElement', el)))
      Promise.all(getters.linkElements.map(async (el) => dispatch('removeElement', el)))
    } else {
      console.log('clear other elements')
      Promise.all(rootGetters['selectedElement/userPlacedElements'].map(async (el) => dispatch(`${namespaceElement}removeElement`, el, { root: true })))
      Promise.all(rootGetters['selectedElement/linkElements'].map(async (el) => dispatch(`${namespaceElement}removeElement`, el, { root: true })))
    }
  },
  setSelectedLogIdIndex: ({ commit, }, logIdIndex) => {
    commit('setSelectedLogIdIndex', logIdIndex)
  },
  setOtherLogIdIndex: ({ commit, }, logIdIndex) => {
    commit('setOtherLogIdIndex', logIdIndex)
  },
  redrawLevel: async ({ getters, dispatch, rootGetters }, namespace) => {
    await dispatch('clearUserElements', namespace.element)
    console.log(`redrawLevel: ${namespace.element}`)
    let boardState = null
    if (namespace.element === '') {
      boardState = getters.selectedSnapshot.absolute_board_state
    } else {
      boardState = getters.otherSnapshot.absolute_board_state
    }
    if (boardState) {
      const components = []
      for (const id of Object.keys(boardState)) {
        const values = boardState[id]
        components.push({
          id,
          scale: (namespace.element === '') ? getters.scale.board : rootGetters['selectedMap/scale'].board,
          transform: (namespace.element === '') ? getters.transform : rootGetters['selectedMap/transform'],
          type: values.type,
          cell: [values.element_x, values.element_y],
          userPlaced: true,
          spec: values.status
        })
      }
      await dispatch(`${namespace.element}createLoadImageElements`, { elementData: components, isBoardElement: true }, { root: true })
      for (const id of Object.keys(boardState)) {
        const values = boardState[id]
        const linkId = values.link
        if (linkId) {
          const sourceEl = (namespace.element === '') ? getters.selectByID(linkId) : rootGetters['selectedElement/selectByID'](linkId)
          const targetEl = (namespace.element === '') ? getters.selectByID(id) : rootGetters['selectedElement/selectByID'](id)
          if (sourceEl && sourceEl.id && targetEl && targetEl.id) {
              const linkData = {
                id: 'abc123',
                sourceEl,
                targetEl,
                isBoardElement: false,
                isLinkElement: true,
                scale: (namespace.element === '') ? getters.scale.board : rootGetters['selectedMap/scale'].board,
                type: elementType.LINK,
                spec: 'active',
                transform: (namespace.element === '') ? getters.transform : rootGetters['selectedMap/transform'],
              }
              dispatch(`${namespace.element}addElement`, new Link(linkData), { root: true })
            } else {
              console.log(`failed to draw link, id: ${id}, namespace: ${namespace.map}`)
              console.log((namespace.element === '') ? getters.elements : rootGetters['selectedElement/elements'])
            }
          }
        }
      dispatch(`${namespace.map}draw`, '', { root: true })
    }
  },
  // renamed these two functions and related variables for clarity
  // selected == PLAYER
  // other == SELECTED
  setSelectedSnapshot: async ({ commit, getters, dispatch }, { logIdIndex, eventIndex, childIndex }) => {
    console.log('setSelectedSnapshot')
    commit('setSelectedLogIdIndex', logIdIndex)
    const snapshot = childIndex ? getters.traces[logIdIndex].events[eventIndex].children[childIndex] : getters.traces[logIdIndex].events[eventIndex]
    commit('setSelectedSnapshot', snapshot)
    await dispatch('redrawLevel', { element: '', map: '' })
  },
  setOtherSnapshot: async ({ commit, getters, dispatch }, { logIdIndex, eventIndex, childIndex }) => {
    console.log(`setOtherSnapshot: ${logIdIndex}, ${eventIndex}, ${childIndex}}`)
    commit('setOtherLogIdIndex', logIdIndex)
    const snapshot = childIndex ? getters.traces[logIdIndex].events[eventIndex].children[childIndex] : getters.traces[logIdIndex].events[eventIndex]
    commit('setOtherSnapshot', snapshot)
    await dispatch('redrawLevel', { element: 'selectedElement/', map: 'selectedMap/' })
  },
  getSetTraces: async ({ commit, dispatch, getters }, index) => {
    try {
      const { data: { traces } } = await aws.getTraces(index)
      // const { test: { testData } } = await aws.hello()
      if (traces) {
        commit('setTraces', traces)
        await dispatch('setSelectedSnapshot', { logIdIndex: 0, eventIndex: 1 })
      } else {
        dispatch('showMessage', `No play session found. Please play level ${getters.selectedLevelString} and return to this screen.`)
      }
    } catch (e) {
      dispatch('showMessage', e)
    }
  },
  logVisualizationEvent: ({ dispatch }, eventData) => {
    dispatch('addLogEvent', eventData)
  }
}

const mutations = {
  setSelectedLogIdIndex: (state, logIdIndex) => {
    state.selectedLogIdIndex = logIdIndex
  },
  setSelectedSnapshot: (state, payload) => {
    state.selectedSnapshot = payload
  },
  setOtherLogIdIndex: (state, logIdIndex) => {
    state.otherLogIdIndex = logIdIndex
  },
  setOtherSnapshot: (state, payload) => {
    state.otherSnapshot = payload
  },
  setTraces: (state, traces) => {
    state.traces = traces
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
}
